// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Niq9M","image":"Header_image__3djZ4","name":"Header_name__qBhB1","info":"Header_info__LRts1","infoRow":"Header_infoRow__3wF-S"};